module.exports = __webpack_public_path__ + "static/media/favicon_cc.2bf9a90e.ico";